import { getValue } from './dataTools';

export default (input: any, map: any) => {
    if (!input) {
        return input;
    }

    return input.replace(/{{\s*([^}]+)\s*}}/g, (_: any, varName: any) => {
        const path = varName.trim().split('.');
        let value = getValue(map, path);

        if (typeof value == 'object') {
            try {
                typeof value == 'object';
                value = JSON.stringify(value);
            } catch (error) {}
        }

        return value;
    });
};
